module.exports = __webpack_public_path__ + "static/media/country_mq.5d1cf9fb.webp";